import React, { useState } from "react";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { SidebarProvider } from "@/contexts/SidebarContext";
import Sidebar from "@/components/Sidebar";
import TopBar from "@/components/TopBar";
import { AvvisiProvider } from "@/contexts/AvvisiContext";

export default function AppLayout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [refreshKey, setRefreshKey] = useState(0);
  const triggerRefresh = () => setRefreshKey((k) => k + 1);

  return (
    <SidebarProvider>
      <AvvisiProvider>
      {/* Sprint UI-GLOBALE — l'area di lavoro (main) è il contenitore che scorre: barre ancorate (schede, scorrimento liste) */}
      <div className="h-screen flex bg-slate-50 overflow-hidden">
        <Sidebar />
        <div className="flex-1 flex flex-col min-w-0 w-full h-screen">
          <TopBar user={user} onLogout={() => { logout(); navigate("/login"); }} />
          <main className="flex-1 overflow-y-auto dms-scroll">
            <div className="max-w-[1600px] mx-auto p-4 sm:p-6 lg:p-8">
              <Outlet context={{ refresh: triggerRefresh, refreshKey }} />
            </div>
          </main>
        </div>
      </div>
      </AvvisiProvider>
    </SidebarProvider>
  );
}
